import type { NavItemType } from "common/types";

import MobileHeader from "./MobileHeader";

import type { JSX, ReactNode } from "react";

interface MobileLayoutProps {
  navItems: NavItemType[];
  children: ReactNode;
  bannersComponent: JSX.Element;
}
export default function MobileLayout({
  navItems,
  children,
  bannersComponent,
}: MobileLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <MobileHeader navItems={navItems} />

      <div className="flex grow flex-col">
        {bannersComponent && (
          <section aria-label="Banners" className="empty:hidden px-4 pt-6">
            {bannersComponent}
          </section>
        )}

        {children}
      </div>
    </div>
  );
}
